const baseFields =  {
    title: null,
    arr: [
        {
            key: 'name',
            type: 'text',
            val: '',
            label: 'Name',
            required: true,
            fullWidth: false
        },
        {
            key: 'timeZone',
            type: 'autoComplete',
            val: 'allTimeZones',
            label: 'TimeZone',
            returnKey: 'name',
            displayKey: 'name',
            required: true,
            fullWidth: false,
        },
        {
            key: 'federalObservances',
            type: 'autoComplete-multiple',
            val: 'allObservance',
            label: 'Federal Observances',
            returnKey: 'name',
            displayKey: 'name',
            required: false,
            fullWidth: true,
        },
    ]
};

const availablityFields = [
    {
        key: 'dayOfWeek',
        type: 'autoComplete',
        val: 'allDays',
        label: 'Day of Week',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        ranges: [
            {
                key: 'opening',
                type: 'time',
                val: '',
                label: 'Opening',
                required: true,
                value: ''
            },
            {
                key: 'closing',
                type: 'time',
                val: '',
                label: 'Closing',
                required: true,
                value: ''
            }
        ]
    },
];


export { baseFields, availablityFields };
